/* eslint-disable arrow-body-style */
import React, { useMemo } from 'react';
import NewRegionSelect from '@/pages/home/components/NewRegionSelect';
import { orderBy } from 'lodash-es';
interface Props {
  className: string;
  value?: {
    genre: string[];
    subgenre: string[];
    type: 'genre' | 'subgenre';
  };
  locale?: 'en-US' | 'zh_CN';
  language?: { [key: string]: string; };
  regionCountry?: any[];
  globalMsg?: string;
  globalMessageHidden?: boolean;
  onChange?: (value: any) => void;
  onClose?: (value: any) => void;
}

const GenreFilter = (props: Props) => {
  const {
    className,
    value: propsValue,
    language,
    regionCountry,
    locale,
    onChange,
    onClose,
  } = props;
  // value指重新处理，处理为地区组件需要的格式
  const value = useMemo(() => ({
    markets: propsValue?.subgenre,
    regions: propsValue?.genre,
    type: propsValue?.type === 'genre' ? 'region' : 'market',
  }), [propsValue]);

  const radioOptions = [
    {
      value: '255',
      text: 'All',
      textCN: '全部',
    }
  ];

  // 按照游戏数量排序，数量一致则按照后端的顺序排
  const sortRegionCountryData = useMemo(() => {
    const sortedData = orderBy(regionCountry, [
      (item) => item?.list?.length ?? 0,
      (item, index) => index
    ], ['desc', 'asc']);
    return sortedData;
  }, [regionCountry]);


  // 对数据格式进行处理，修改为新国家筛选器的格式
  const regionCountryOption = useMemo(() => sortRegionCountryData?.map((item) => {
    const { code, name_ch: textCN, name_en: text, list } = item;
    const itemObjChildren = list?.map((childItem: { code: any; name_en: string; name_ch: string; }) => ({
      ...(childItem || {}),
      text: childItem?.name_en || childItem?.name_ch,
      textCN: childItem?.name_ch || childItem?.name_en,
      value: childItem?.code,
      bubbleContent: childItem?.name_en || childItem?.name_ch,
      bubbleContentCN: childItem?.name_ch || childItem?.name_en,
    })
    );
    // 地区筛选器组件内部region_key和value都是字符串类型的，在这里转换一下，不然选中的时候拿不到type值
    // 另外和后端确认过，这个地方接口返回的下拉id是int类型，但是在页面中传参需要给其他接口传字符串类型
    return {
      ...item,
      children: itemObjChildren,
      text,
      textCN,
      value: code,
    };
  }), [sortRegionCountryData]);

  // 关闭时调用
  const handleCloseRegionSelect = (value: any) => {
    onClose?.(value);
  };

  return (
    <>
      <NewRegionSelect
        language={language}
        value={value}
        tagNumber={10}
        className={className}
        selectFilterType={'category'}
        dropdownClassName='region-selector-dropdown'
        radioOptions={radioOptions}
        options={regionCountryOption || []}
        onCloseReginSelect={handleCloseRegionSelect}
        onChange={(val) => {
          // 修复，清空全选的时候，筛选器回显不是all的问题
          const value = val;
          if(value.markets.length ===1 && value.markets[0] === '255' && value.regions.length === 0 && value.type === 'region'){
            value.type = 'market';
          }
          onChange?.(value);
          handleCloseRegionSelect(value);
        }}
        closeOnScroll={true}
        popularList={[]}
        locale={locale}
      />
    </>
  );
};

export default GenreFilter;
